import { render, staticRenderFns } from "./SetupBackups.vue?vue&type=template&id=22532b53&scoped=true&"
import script from "./SetupBackups.vue?vue&type=script&lang=js&"
export * from "./SetupBackups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22532b53",
  null
  
)

export default component.exports